import Client from './Client'

export default class Affiliation extends Client {
  async fetchAffiliations(token, payload) {
    try {
      const query =  {
        scope: 'emiter',
        offset: payload.offset,
        limit: payload.limit
      }
      return await this.request(token, 'get', 'affiliation', null, query)
    } catch (error) {
      throw new Error(error)
    }
  }

  async fetchAffiliationUsers(token, code) {
    try {
      return await this.request(token, 'get', `affiliation/${code}/user`, null, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async deleteAffiliationUser(token, code, userId) {
    try {
      return await this.request(token, 'delete', `affiliation/${code}/user/${userId}`, null, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async addAffiliationUser(token, code, email) {
    try {
      return await this.request(token, 'post', `affiliation/${code}/user`, { email }, null)
    } catch (error) {
      throw new Error(error)
    }
  }
}
